import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
  Box,
  Typography,
  TextField,
  Snackbar,
} from "@mui/material";
import {
  Facebook,
  Twitter,
  LinkedIn,
  Instagram,
  Close as CloseIcon,
  ContentCopy,
} from "@mui/icons-material";

const ShareModal = ({ open, handleClose, url = window.location.href }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const shareOptions = [
    {
      name: "Facebook",
      icon: <Facebook />,
      color: "#1877F2",
      url: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    },
    {
      name: "Twitter",
      icon: <Twitter />,
      color: "#1DA1F2",
      url: `https://twitter.com/intent/tweet?url=${url}`,
    },
    {
      name: "LinkedIn",
      icon: <LinkedIn />,
      color: "#0A66C2",
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
    },
    {
      name: "Instagram",
      icon: <Instagram />,
      color: "#E4405F",
      url: `https://instagram.com`,
    },
  ];

  const handleShare = (platform) => {
    window.open(platform.url, "_blank");
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(url);
    setSnackbarOpen(true);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px",
            p: { xs: 2, sm: 3 },
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 0,
            mb: 2,
          }}
        >
          <Typography variant="h6" component="div">
            Share
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
            sx={{
              "&:hover": {
                color: "black",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 0 }}>
          <Typography
            variant="subtitle2"
            sx={{ mb: 2, color: "text.secondary" }}
          >
            Share this link via
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              flexWrap: "wrap",
              mb: 4,
            }}
          >
            {shareOptions.map((platform) => (
              <IconButton
                key={platform.name}
                onClick={() => handleShare(platform)}
                sx={{
                  bgcolor: platform.color,
                  color: "white",
                  width: 48,
                  height: 48,
                  "&:hover": {
                    bgcolor: platform.color,
                    transform: "scale(1.1)",
                  },
                  transition: "transform 0.2s",
                }}
              >
                {platform.icon}
              </IconButton>
            ))}
          </Box>

          <Typography
            variant="subtitle2"
            sx={{ mb: 2, color: "text.secondary" }}
          >
            Or copy link
          </Typography>

          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField
              fullWidth
              value={url}
              variant="outlined"
              size="small"
              InputProps={{
                readOnly: true,
                sx: {
                  borderRadius: "4px",
                },
              }}
            />
            <Button
              variant="contained"
              onClick={copyToClipboard}
              startIcon={<ContentCopy />}
              sx={{
                bgcolor: "#299B8D",
                "&:hover": {
                  bgcolor: "#299B8D",
                },
                borderRadius: "4px",
                whiteSpace: "nowrap",
              }}
            >
              Copy
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        message="Link copied to clipboard"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </>
  );
};

const ShareButton = ({ width }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        variant="outlined"
        sx={{
          flex: 1,
          width: { width },
          color: "#374151",
          borderColor: "#D1D5DB",
          fontWeight: 500,
          p: "16px",
          fontFamily: "'Montserrat', sans-serif",
          borderRadius: "1000px",
          fontSize: "0.875rem",

          textTransform: "none",
          backgroundColor: "#fff",
          "&:hover": {
            backgroundColor: "#F9FAFB",
            borderColor: "#9CA3AF",
            color: "#374151",
          },
        }}
      >
        Share
      </Button>

      <ShareModal open={open} handleClose={() => setOpen(false)} />
    </>
  );
};
export { ShareModal };
export default ShareButton;
